import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { IPublishButtonProps } from './types';

export const PublishButton = (props: IPublishButtonProps) => {
  const { text, isPending, handleButtonClick } = props;

  return (
    <Button
      data-name="PublishButton"
      type="button"
      theme="fill_primary"
      onClick={handleButtonClick}
      loading={isPending}
      fullWidth
    >
      {text}
    </Button>
  );
};
